import { EnumValueObject } from "../EnumValueObject";
import { InvalidHTTPCodeError } from "../errors/InvalidHTTPCodeError";

export enum HTTPCodes {
  UNKNOWN = "-1",
  BAD_REQUEST = "400",
  UNAUTHORIZED = "401",
  FORBIDDEN = "403",
  NOT_FOUND = "404",
  TOO_MANY_REQUESTS = "429",
  INTERNAL_SERVER_ERROR = "500",
}

export class HTTPCode extends EnumValueObject<HTTPCodes> {
  constructor(value: number) {
    super(String(value), Object.values(HTTPCodes));
  }

  public isUnknown() {
    return this.getValue() === HTTPCodes.UNKNOWN;
  }

  public isBadRequest() {
    return this.getValue() === HTTPCodes.BAD_REQUEST;
  }

  public isUnauthorized() {
    return this.getValue() === HTTPCodes.UNAUTHORIZED;
  }

  public isForbidden() {
    return this.getValue() === HTTPCodes.FORBIDDEN;
  }

  public isNotFound() {
    return this.getValue() === HTTPCodes.NOT_FOUND;
  }

  public isTooManyRequests() {
    return this.getValue() === HTTPCodes.TOO_MANY_REQUESTS;
  }

  public isInternalServerError() {
    return this.getValue() === HTTPCodes.INTERNAL_SERVER_ERROR;
  }

  protected throwErrorForInvalidValue(value: HTTPCodes): void {
    throw new InvalidHTTPCodeError(value.toString());
  }
}
